import React from 'react';
import { Ship, AlertTriangle, CheckCircle2, Search } from 'lucide-react';

const S4MigrationWizard = ({ data = {}, setData }) => {
  
  const handleToggle = (option) => {
    setData({
      ...data,
      migrationOpts: { ...data.migrationOpts, [option]: !data.migrationOpts[option] }
    });
  };

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left">
      
      {/* NOTA DEL EXPERTO EN MIGRACIÓN */}
      <div className="bg-sky-900/10 border-l-4 border-sky-600 p-6 mb-10 rounded-r-3xl flex gap-4 items-start shadow-sm">
        <div className="bg-sky-600 p-2 rounded-xl text-white shadow-lg shadow-sky-500/20 shrink-0">
            <Ship size={20}/>
        </div>
        <div>
            <p className="text-[11px] text-sky-800 font-black uppercase tracking-widest mb-1 italic">S/4HANA Transition Guide:</p>
            <p className="text-[11px] text-slate-600 leading-relaxed font-medium">
                Esta herramienta analiza objetos **ECC** para adaptarlos al paradigma de **S/4HANA**. 
                Identifica el reemplazo de tablas clásicas (como MSEG/MKPF por MATDOC o BSEG por ACDOCA), detecta la necesidad de 
                ajustar la longitud del campo MATNR (40 caracteres) y sugiere correcciones basadas en la **Simplification List**. 
                Pegue su código o lista de tablas para obtener el plan de remediación técnica.
            </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
        
        {/* CONFIGURACIÓN DE ESCANEO */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-sky-500">
          <label className="text-[10px] font-black text-sky-400 uppercase block mb-6 border-b border-slate-800 pb-2 flex items-center gap-2">
            <Search size={14}/> Migration Scope & Compliance
          </label>
          
          <div className="space-y-4 bg-slate-800/50 p-6 rounded-2xl border border-white/5">
            <label className="flex items-center justify-between group cursor-pointer">
                <span className="text-[10px] font-bold uppercase tracking-wider group-hover:text-sky-400 transition-colors">Universal Journal Check (ACDOCA)</span>
                <input type="checkbox" className="w-4 h-4 rounded border-none bg-slate-700 text-sky-500 focus:ring-0" 
                    checked={data.migrationOpts?.acdoca || false} onChange={() => handleToggle('acdoca')} />
            </label>
            
            <label className="flex items-center justify-between group cursor-pointer">
                <span className="text-[10px] font-bold uppercase tracking-wider group-hover:text-sky-400 transition-colors">Material Doc. Merging (MATDOC)</span>
                <input type="checkbox" className="w-4 h-4 rounded border-none bg-slate-700 text-sky-500 focus:ring-0" 
                    checked={data.migrationOpts?.matdoc || false} onChange={() => handleToggle('matdoc')} />
            </label>

            <label className="flex items-center justify-between group cursor-pointer">
                <span className="text-[10px] font-bold uppercase tracking-wider group-hover:text-sky-400 transition-colors">Business Partner (CVI) Adaptation</span>
                <input type="checkbox" className="w-4 h-4 rounded border-none bg-slate-700 text-sky-500 focus:ring-0" 
                    checked={data.migrationOpts?.bp || false} onChange={() => handleToggle('bp')} />
            </label>

            <label className="flex items-center justify-between group cursor-pointer">
                <span className="text-[10px] font-bold uppercase tracking-wider group-hover:text-sky-400 transition-colors">Field Length Extension (MATNR 40)</span>
                <input type="checkbox" className="w-4 h-4 rounded border-none bg-slate-700 text-sky-500 focus:ring-0" 
                    checked={data.migrationOpts?.matnr || false} onChange={() => handleToggle('matnr')} />
            </label>
          </div>
        </div>

        {/* ALERTAS DE COMPATIBILIDAD */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-sky-500">
          <label className="text-[10px] font-black text-sky-400 uppercase block mb-6 border-b border-slate-800 pb-2 flex items-center gap-2">
                <AlertTriangle size={14}/> Critical Migration Checks
            </label>
            <div className="space-y-4">
                <div className="p-4 bg-amber-50 rounded-2xl border border-amber-100">
                    <p className="text-[9px] font-black text-amber-800 uppercase mb-1">Database Access</p>
                    <p className="text-[10px] text-slate-500 font-medium">Se detectará el uso de DB HINTS o accesos directos que fallarán en HANA.</p>
                </div>
                <div className="p-4 bg-blue-50 rounded-2xl border border-blue-100">
                    <p className="text-[9px] font-black text-blue-800 uppercase mb-1">Functional Impact</p>
                    <p className="text-[10px] text-slate-500 font-medium">Mapeo automático de tablas de agregados y de índices (BSIS, BSAS, etc) a Vistas de Compatibilidad.</p>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default S4MigrationWizard;